
export enum SelectedSystemType {
    LITT_SHORT = "LITT_SHORT",
    LITT_LONG = "LITT_LONG",
    IRON_CONDOR = "IRON_CONDOR"
}
